/**
 * injects the google map api script to the index.html,
 * and set the app to a ready state once the script has successfully
 * loaded
 */
export default function initializeGoogle(callback) {
  const apiKey = process.env.GOOGLE_API_KEY;
  const googleMapsScript = document.getElementById('googleMaps');

  if (googleMapsScript) {
    callback();
    return;
  }

  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMap&v=3.exp&libraries=places`;
  script.id = 'googleMaps';
  script.async = true;
  window.initMap = callback;

  document.body.appendChild(script);
}
